<template>
  <section class="payment-item">
    <div class="d-flex align-items-center p-3">
      <div class="payment-item__icon">
        <picture class="img-fluid">
          <source
            srcset="@/assets/film-icon.webp"
            type="image/webp">
          <source
            srcset="@/assets/film-icon.png"
            type="image/png">
          <img
            src="@/assets/film-icon.png"
            alt=""
            width="96"
            height="78"
            class="img-fluid">
        </picture>
      </div>
      <div class="px-3 payment-item__content">
        <p class="my-0 text-truncate">检查部位：{{ patientInfo.check_item }}</p>
        <p class="my-0 text-truncate">检查编号：{{ patientInfo.image_id }}</p>
        <p class="my-0 text-truncate">检查时间：{{ patientInfo.check_time }}</p>
      </div>
      <div class="text-warning text-right payment-item__price">{{ price|currency }}</div>
      <!-- <div class="pl-2">
        <van-checkbox v-model="checked"/>
      </div> -->
    </div>
  </section>
</template>

<script>
import accounting from 'accounting';

export default {
  name: 'PaymentListItem',
  filters: {
    currency(value) {
      return accounting.formatMoney(value / 100, '￥', 2, ',', '.');
    },
  },
  props: {
    patientInfo: {
      type: Object,
      required: true,
      default() {
        return {
          image_id: '',
          check_item: '',
          check_time: '',
        };
      },
    },
    price: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data() {
    return {
      checked: true,
    };
  },
};
</script>

<style scoped>
.payment-item {
  background-color: #fff;
}

.payment-item__icon {
  width: 48px;
}

.payment-item__price {
  width: 5rem;
}

.payment-item__content {
  flex: 1;
  max-width: calc(100% - 190px);
}
</style>
